(function () {
  'use strict';

  angular.module('app.performanceReportTierPerformance',[])
    .factory('performanceReportTierPerformanceService', ['$q', '$http', '$rootScope',
    function ($q, $http, $rootScope)
    {
        var service = {};

        function checkResponse(data) {
            return data;
        }

        function getMessage(data) {
            if (data) {
                return data.message;
            }
            return false;
        }

        function handleRequest(url) {
            var deferred = $q.defer(), result = 'requestFail';
            $http.get(url)
            .success(function (data) {
                var dataRes = angular.fromJson(data);

                if (checkResponse(dataRes)) {
                    deferred.resolve(dataRes);
                } else {
                    deferred.reject(getMessage(dataRes) || result);
                }
            })
            .error(function () {
                deferred.reject(result);
            });

            return deferred.promise;
        }

        function getTierPerformanceData(params)
        {
            var url_getTierPerformance = $rootScope.apiUrl + 'measure/getTierPerformance?' + $.param(params);
            return handleRequest(url_getTierPerformance);
        }

        service.getTierPerformanceData = getTierPerformanceData;

        return service;
        }
    ]);
})();